function setStateByHours() {
  const supportHours = calendarConfig.supportHours || [];
  const manualExtendedHours = calendarConfig.manualExtendedHours || {};
  const closedWeekdays = calendarConfig.closedWeekdays || [];
  const extraClosedDates = calendarConfig.extraClosedDates || [];

  const hours = getSupportHoursForToday();
 
  if (!hours) {
     $('.oteviraci p').html('<span class="closed">Nyní máme zavřeno</span>');
    $(".openBox .status").text("Dnes máme zavřeno");
    $(".openBox .status").addClass("closed");
    $(".openBox .status").removeClass("open");
  } else if (!isSupportOnline(hours)) {
    $('.oteviraci p').html('<span class="closed">Nyní máme zavřeno</span>');
    $(".openBox .status").text(
      "Dnes máme otevřeno " + hours.open + " - " + hours.close
    );
    $(".openBox .status").addClass("closed");
    $(".openBox .status").removeClass("open");
  } else {
     $('.oteviraci p').html('<span class="open">Nyní máme otevřeno</span>');
    $(".openBox .status").text(
      "Dnes máme otevřeno " + hours.open + " - " + hours.close
    );
    $(".openBox .status").addClass("open");
    $(".openBox .status").removeClass("closed");
  }

  function fixedHolidays(year) {
    return [
      `${year}-01-01`,
      `${year}-05-01`,
      `${year}-05-08`,
      `${year}-07-05`,
      `${year}-07-06`,
      `${year}-09-28`,
      `${year}-10-28`,
      `${year}-11-17`,
      `${year}-12-24`,
      `${year}-12-25`,
      `${year}-12-26`,
    ];
  }

  function getEasterDates(year) {
    let f = Math.floor,
      a = year % 19,
      b = f(year / 100),
      c = year % 100,
      d = f(b / 4),
      e = b % 4,
      g = f((8 * b + 13) / 25),
      h = (19 * a + b - d - g + 15) % 30,
      i = f(c / 4),
      k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7,
      m = f((a + 11 * h + 22 * l) / 451),
      month = f((h + l - 7 * m + 114) / 31),
      day = ((h + l - 7 * m + 114) % 31) + 1;

    const sunday = new Date(year, month - 1, day);
    const monday = new Date(year, month - 1, day + 1);

    return [
      sunday.toISOString().slice(0, 10),
      monday.toISOString().slice(0, 10),
    ];
  }

  function toMinutes(time) {
    if (!time) return null;

    const [h, m] = time.split(":");

    return parseInt(h) * 60 + parseInt(m);
  }

  function getSupportHoursForToday() {
    const now = new Date();
    const year = now.getFullYear();
    const today = now.toISOString().slice(0, 10);
    const weekday = now.getDay() === 0 ? 7 : now.getDay();

    const weekdayCodes = {
      1: "po",
      2: "ut",
      3: "st",
      4: "ct",
      5: "pa",
      6: "so",
      7: "ne",
    };

    function getSupportHoursFromArray(dayCode) {
      const entry = supportHours.find(function (item) {
        return item[0] === dayCode;
      });

      if (!entry || !entry[1]) {
        return null;
      }

      const normalizedRange = String(entry[1]).replace(/\s+/g, "");
      const rangeMatch = normalizedRange.match(
        /^(\d{1,2}:\d{2})-(\d{1,2}:\d{2})$/
      );

      if (!rangeMatch) {
        return null;
      }

      return {
        open: rangeMatch[1],
        close: rangeMatch[2],
      };
    }

    if (manualExtendedHours[today]) {
      return manualExtendedHours[today];
    }

    if (extraClosedDates.includes(today)) {
      return null;
    }

    const holidays = [
      ...fixedHolidays(year),
      ...getEasterDates(year),
    ];

    if (holidays.includes(today)) {
      return null;
    }

    return getSupportHoursFromArray(weekdayCodes[weekday]);
  }

  function isSupportOnline(hours) {
    if (!hours) return false;

    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const open = toMinutes(hours.open);
    const close = toMinutes(hours.close);

    return currentMinutes >= open && currentMinutes < close;
  }

  function isHoliday(date) {
    const year = date.getFullYear();
    const iso = date.toISOString().slice(0, 10);

    const holidays = [
      ...fixedHolidays(year),
      ...getEasterDates(year),
    ];

    return holidays.includes(iso);
  }

  function isWorkingDay(date) {
    const day = date.getDay(); // 0 = ne, 6 = so
    const iso = date.toISOString().slice(0, 10);

    return (
      !closedWeekdays.includes(day) &&
      !extraClosedDates.includes(iso) &&
      !isHoliday(date)
    );
  }

  function afterDeliveryCutoff(now) {
    const [h, m] = deliveryHours.split(":").map(Number);

    return (
      now.getHours() * 60 + now.getMinutes() >=
      h * 60 + m
    );
  }

  function addWorkingHours(startDate, hoursToAdd) {
    const date = new Date(startDate);
    let remaining = hoursToAdd;

    while (remaining > 0) {
      date.setHours(date.getHours() + 1);

      if (isWorkingDay(date)) {
        remaining--;
      }
    }

    return date;
  }

  function formatDispatchDate(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const target = new Date(date);
    target.setHours(0, 0, 0, 0);

    const diffDays = Math.round(
      (target - today) / (1000 * 60 * 60 * 24)
    );

    const day = date.getDate();
    const month = date.getMonth() + 1;

    if (diffDays === 0) {
      return "odešleme dnes";
    }

    if (diffDays === 1) {
      return `odešleme zítra ${day}. ${month}.`;
    }

    if (diffDays === 2) {
      return `odešleme pozítří ${day}. ${month}.`;
    }

    return `odešleme ${day}. ${month}`;
  }

  /**
   * Vypočítá datum odeslání podle dostupnosti.
   * Pokud je dostupnost "skladem" a už je po limitu,
   * posune datum na další pracovní den.
   */
  function getDispatchDateByAvailability(availabilityText) {
    if (availabilityText !== "skladem, ihned k odeslání") {
      return null;
    }

    const now = new Date();
    const [h, m] = deliveryHours.split(":").map(Number);
    const cutoffMinutes = h * 60 + m;
    const currentMinutes =
      now.getHours() * 60 + now.getMinutes();

    const dispatch = new Date(now);

    if (currentMinutes >= cutoffMinutes) {
      do {
        dispatch.setDate(dispatch.getDate() + 1);
      } while (!isWorkingDay(dispatch));
    }

    dispatch.setHours(9, 0, 0, 0);

    return dispatch;
  }
}

setStateByHours();